// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5043":"e3eb6ec4","5864":"f9d974e3","8033":"6aa7e6de"}[chunkId] + ".chunk.css";
};